/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coached_Training_CrumbInputs */

const en_coached_training_crumb = /** @type {(inputs: Coached_Training_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training`)
};

const pl_coached_training_crumb = /** @type {(inputs: Coached_Training_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening`)
};

/**
* | output |
* | --- |
* | "Training" |
*
* @param {Coached_Training_CrumbInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coached_training_crumb = /** @type {((inputs?: Coached_Training_CrumbInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coached_Training_CrumbInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coached_training_crumb(inputs)
	return en_coached_training_crumb(inputs)
});